
interface KeyFeature {
  title: string;
  description: string;
}

const KeyFeaturesSection = () => {
  const keyFeatures: KeyFeature[] = [
    {
      title: "True Agentic AI",
      description: "Unlike solutions with bolted-on AI features, our platform was built from the ground up with agentic AI at its core, enabling autonomous decision-making and response capabilities that continuously improve over time."
    },
    {
      title: "Unified Platform",
      description: "Spharaka Autonomous Cyber Defence Platform integrates endpoint, network, cloud, and application security into a single cohesive platform, eliminating the need for multiple disparate tools and providing comprehensive visibility across your entire attack surface."
    },
    {
      title: "Autonomous Operations",
      description: "Our platform can operate independently 24/7, detecting and neutralizing threats without constant human supervision, dramatically reducing the operational burden on your security team."
    },
    {
      title: "Intuitive User Experience",
      description: "Designed for both security experts and IT generalists, our platform features a clean, intuitive interface that simplifies complex security operations without sacrificing depth or capability."
    },
    {
      title: "Rapid Time to Value",
      description: "Deploy in hours, not months, with immediate threat detection and minimal configuration required. Our platform begins delivering security value from day one of implementation."
    },
    {
      title: "Future-Proof Security",
      description: "Our AI-driven architecture continuously adapts to new threats without requiring manual updates or signature files, ensuring you stay protected against emerging attack vectors."
    }
  ];

  return (
    <section className="py-16 relative overflow-hidden">
      {/* Optimized Background Image */}
      <picture className="absolute inset-0">
        <source 
          media="(max-width: 768px)" 
          srcSet="/lovable-uploads/58957d2d-8978-4947-a034-03d9d505c800.png"
        />
        <div 
          className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(/lovable-uploads/58957d2d-8978-4947-a034-03d9d505c800.png)',
            backgroundAttachment: 'fixed',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        />
      </picture>
      
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/60"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">What <span className="text-[#8932c8]">Sets Us Apart</span></h2>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            Spharaka delivers a unique approach to cybersecurity that transforms how organizations detect, 
            investigate, and respond to threats.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {keyFeatures.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white/95 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white transition-all duration-300 shadow-lg"
            >
              <h3 className="text-xl font-semibold mb-2 text-gray-900">{feature.title}</h3>
              <p className="text-gray-700">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyFeaturesSection;
